export const frameworkTypes = [
  {
    label: 'BRSR',
    value: 'BRSR'
  },
  {
    label: 'GRI',
    value: 'GRI'
  },
  {
    label: 'TCFD',
    value: 'TCFD'
  }
];

export const frameworkDocuments = [
  {
    label: 'AOC-1 (Statement of Subsidiaries/Associates)',
    value: 'AOC-1_Statement_of_Subsidiaries_Associates',
    framework: 'BRSR'
  },
  {label: 'AOC-4', value: 'AOC_4', framework: 'BRSR'},
  {
    label: 'MGT-7 (Annual Return)',
    value: 'MGT_7_Annual_Return',
    framework: 'BRSR'
  },
  {label: 'Form INC-22A', value: 'Form_INC_22A', framework: 'BRSR'},
  {
    label: 'DHRP (Draft Red Herring Prospectus)',
    value: 'DHRP_Draft_Red_Herring_Prospectus',
    framework: 'BRSR'
  },
  {label: 'Form CRA-2', value: 'Form_CRA_2', framework: 'BRSR'},
  {label: 'Form CRA-4', value: 'Form_CRA_4', framework: 'BRSR'},
  {label: 'Form ADT-1', value: 'Form_ADT_1', framework: 'BRSR'},
  {label: 'Form ADT-2', value: 'Form_ADT_2', framework: 'BRSR'},
  {label: 'Form ADT-3', value: 'Form_ADT_3', framework: 'BRSR'},
  {label: 'Form FTE', value: 'Form_FTE', framework: 'BRSR'},
  {label: 'DIR-8', value: 'DIR_8', framework: 'BRSR'},
  {
    label: 'Board Meeting Minutes',
    value: 'Board_Meeting_Minutes',
    framework: 'BRSR'
  },
  {
    label: 'DIR-12 (Particulars of Appointment of Directors)',
    value: 'DIR_12_Particulars_of_Appointment_of_Directors',
    framework: 'BRSR'
  },
  {
    label: 'Form 5 (EPFO Return)',
    value: 'Form_5_EPFO_Return',
    framework: 'BRSR'
  },
  {
    label: 'Factory License',
    value: 'Factory_License',
    framework: 'BRSR'
  },
  {
    label: 'Form 6A (Annual ESI Contribution Report)',
    value: 'Form_6A_Annual_ESI_Contribution_Report',
    framework: 'BRSR'
  },
  {
    label: 'Environmental Clearance Certificates (EC)',
    value: 'Environmental_Clearance_Certificates_EC',
    framework: 'BRSR'
  },
  {
    label: 'Energy Audit Reports',
    value: 'Energy_Audit_Reports',
    framework: 'BRSR'
  },
  {
    label: 'Environmental Impact Assessment (EIA) Report',
    value: 'Environmental_Impact_Assessment_EIA_Report',
    framework: 'BRSR'
  },
  {
    label: 'Consent to Establish (CTE)',
    value: 'Consent_to_Establish_CTE',
    framework: 'BRSR'
  },
  {
    label: 'Consent to Operate (CTO)',
    value: 'Consent_to_Operate_CTO',
    framework: 'BRSR'
  },
  {
    label: 'Form I (Application for Environmental Clearance)',
    value: 'Form_I_Application_for_Environmental_Clearance',
    framework: 'BRSR'
  },
  {
    label: 'Environmental Management Plan (EMP)',
    value: 'Environmental_Management_Plan_EMP',
    framework: 'BRSR'
  },
  {
    label: 'Water Cess Returns',
    value: 'Water_Cess_Returns',
    framework: 'BRSR'
  },
  {
    label: 'Extended Producer Responsibility (EPR) Plan',
    value: 'Extended_Producer_Responsibility_EPR_Plan',
    framework: 'BRSR'
  },
  {
    label: 'Environmental Compliance Reports (Form V)',
    value: 'Environmental_Compliance_Reports_Form_V',
    framework: 'BRSR'
  },
  {
    label: 'Form CSR-1 (Corporate Social Responsibility Report)',
    value: 'Form_CSR_1_Corporate_Social_Responsibility_Report',
    framework: 'BRSR'
  },
  {
    label: 'Form CSR-2 (Corporate Social Responsibility Report)',
    value: 'Form_CSR_2_Corporate_Social_Responsibility_Report',
    framework: 'BRSR'
  },
  {
    label: 'Social Impact Assessment (SIA) Report',
    value: 'Social_Impact_Assessment_SIA_Report',
    framework: 'BRSR'
  },
  {
    label: 'Public Consultation Report',
    value: 'Public_Consultation_Report',
    framework: 'BRSR'
  },
  {label: 'Form GNL-1', value: 'Form_GNL_1', framework: 'BRSR'}
];
